import filterFactoryModule, {
  numberFilter,
  selectFilter,
  textFilter,
} from 'react-bootstrap-table2-filter';

export const filterFactory = filterFactoryModule.default ?? filterFactoryModule;

export { numberFilter, selectFilter, textFilter };
